import { render, staticRenderFns } from "./PreferredStorePopover.vue?vue&type=template&id=ed8d881a&"
import script from "./PreferredStorePopover.vue?vue&type=script&lang=js&"
export * from "./PreferredStorePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports